import "@popperjs/core";
import "bootstrap";
import { ValidationService } from "aspnet-client-validation";
import "../styles/index.scss";
import "./components/select";
import "./components/video-controls";
import "./components/splide";
import "./components/faq-block";
import "./components/search-course-block";
import "./components/image-aspect-ratio";
import "./components/header";
import "./components/two-column-collection-block";
import "./components/scrolling-animation-block";
import "./components/side-navigation";
import "./components/modal";

// ASP.NET Core Client Side Validation Setup
const service = new ValidationService();
service.bootstrap();